import React from 'react';

import GroupPhoto from '../../../assets/images/captivision/story/group-photo.jpg';
import UTSeal from '../../../assets/images/captivision/story/ut-austin-seal.svg';
import ZoomCall from '../../../assets/images/captivision/story/zoom-call.jpg';
import Aisha from '../../../assets/images/captivision/story/aisha.jpg';
import IPhone from '../../../assets/images/captivision/story/iphone.jpg';
import MamySiraWebcam from '../../../assets/images/captivision/story/mamy-sira-webcam.jpg';
import Prototype from '../../../assets/images/captivision/story/prototype.jpg';
import TeddyAndMamySira from '../../../assets/images/captivision/story/tewodros-and-mamy-sira.jpg';

// The story's photographs, shared by every language. Each translation of the
// story places them with <Photo> and writes its own description of each.

const PHOTOS = {
    group: { src: GroupPhoto, width: 1400, height: 1050 },
    seal: { src: UTSeal, width: 227, height: 227, className: 'cv-seal' },
    zoomCall: { src: ZoomCall, width: 1800, height: 509 },
    aisha: { src: Aisha, width: 619, height: 1100 },
    iphone: { src: IPhone, width: 619, height: 1100 },
    mamySiraWebcam: { src: MamySiraWebcam, width: 619, height: 1100 },
    prototype: { src: Prototype, width: 720, height: 638 },
    teddyAndMamySira: { src: TeddyAndMamySira, width: 960, height: 1280 }
}

export const Photo = ({ name, alt }) => {
    const { src, width, height, className } = PHOTOS[name];

    return <img className={className} src={src} width={width} height={height} alt={alt} loading="lazy" />
}

// a row of photos; `layout` is '2-1', '3', 'half' or empty for one full-width image
export const PhotoRow = ({ layout, children }) => (
    <div className={`cv-frow${layout ? ` cv-frow-${layout}` : ''}`}>
        {children}
    </div>
)
